const route = {
	name: 'ecommerce',
	path: '/ecommerce',
	component: () => import('@/pages/ecommerce/page-ecommerce'),
	children: [
		{
			name: 'orders',
			path: 'orders',
			meta: {
				title: 'Pedidos',
			},
			component: () => import('@/pages/ecommerce/pages-ecommerce-order'),
		},
		{
			name: 'banner',
			path: 'banner',
			meta: {
				title: 'Banners',
			},
			component: () => import('@/pages/ecommerce/page-banners'),
		},
		{
			name: 'new-banner',
			path: 'new-banner',
			meta: {
				title: 'Crear Banners',
			},
			component: () => import('@/pages/ecommerce/page-create-banner'),
		},
		{
			name: 'edit-banner',
			path: ':id/edit-banner',
			meta: {
				title: 'Editar Banners',
			},
			props: true,
			component: () => import('@/pages/ecommerce/page-create-banner'),
		},
		{
			name: 'products-ecommerce',
			path: 'products',
			meta: {
				title: 'Productos Ecommerce',
			},
			component: () => import('@/pages/ecommerce/product-ecommerce'),
		},
		{
			name: 'create-product',
			path: 'products/new',
			meta: {
				title: 'Nuevo Producto',
			},
			component: () => import('@/pages/ecommerce/page-create-product'),
		},
		{
			name: 'edit-product-ecommerce',
			path: 'products/:id/edit',
			meta: {
				title: 'Editar Producto',
			},
			component: () => import('@/pages/ecommerce/page-create-product'),
			props: true,
		},
		{
			name: 'filters',
			path: 'filters',
			meta: {
				title: 'Filtros',
			},
			component: () => import('@/pages/ecommerce/page-filters-ecommerce'),
		},
		{
			name: 'product-sections',
			path: 'products-sections',
			meta: {
				title: 'SECCIONES DE PRODUCTOS',
			},
			component: () => import('@/pages/ecommerce/page-products-sections'),
		},
		{
			name: 'categories-ecommerce',
			path: 'categories',
			meta: {
				title: 'Categorías',
			},
			component: () => import('@/pages/ecommerce/page-categories'),
		},
		{
			name: 'edit-order',
			path: 'order/:id/edit',
			meta: {
				title: 'Editar pedido',
			},
			component: () => import('@/pages/ecommerce/page-edit-order'),
		},
		{
			name: 'configuration',
			path: 'configuration/:id',
			meta: {
				title: 'Configuración',
			},
			component: () => import('@/pages/ecommerce/page-configuration'),
		},
		{
			name: 'cost-of-shipping',
			path: 'cost-of-shipping',
			meta: {
				title: 'Costo de Envío',
			},
			component: () => import('@/pages/ecommerce/page-cost-shipping'),
		},
		{
			name: 'commerce',
			path: 'commerce',
			meta: {
				title: 'Comercio',
			},
			component: () => import('@/pages/ecommerce/page-commerce-ecommerce'),
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/ecommerce.js